import { render, staticRenderFns } from "./ParentModal.vue?vue&type=template&id=71c80fef&scoped=true&"
import script from "./ParentModal.vue?vue&type=script&lang=js&"
export * from "./ParentModal.vue?vue&type=script&lang=js&"
import style0 from "./ParentModal.vue?vue&type=style&index=0&id=71c80fef&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c80fef",
  null
  
)

export default component.exports